import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import VendorRequestList from "../vendor-request-list";
import VendorList from "../vendor-list";
import VendorIntegrations from "../vendor-integrations";
import { getOfflineData } from "../../utils/offline-services";
import { VENDOR_ONBOARD_USERS } from "../../utils/constants";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div hidden={value !== index} {...other}>
      {value === index && <>{children}</>}
    </div>
  );
}

export default function VendorOnboardHome() {
  const [value, setValue] = React.useState(0);
  const user = getOfflineData("user") || {};
  const isFinanceUser = user.role === VENDOR_ONBOARD_USERS.FINANCE_USER;

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
        >
          <Tab label="Vendor Form" />
          <Tab label="Vendor Master" />
          {isFinanceUser && <Tab label="Vendor Integrations" />}
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <VendorRequestList />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <VendorList />
      </TabPanel>
      {isFinanceUser && (
        <TabPanel value={value} index={2}>
          <VendorIntegrations />
        </TabPanel>
      )}
    </Box>
  );
}
